import { Transition } from "@headlessui/react";
import React from "react";
import toast from "react-hot-toast";
import Prices from "components/Prices";
import NcImage from "shared/NcImage/NcImage";

function NotifyCart(itemData: any) {
  toast.custom(
    (t) => (
      <Transition
        appear
        show={t.visible}
        role="alert"
        className="p-4 max-w-md w-full bg-white dark:bg-slate-800 shadow-lg rounded-2xl pointer-events-auto ring-1 ring-black/5 dark:ring-white/10 text-slate-900 dark:text-slate-200"
        enter="transition-all duration-150"
        enterFrom="opacity-0 translate-x-20"
        enterTo="opacity-100 translate-x-0"
        leave="transition-all duration-150"
        leaveFrom="opacity-100 translate-x-0"
        leaveTo="opacity-0 translate-x-20"
      >
        <p className="block text-base font-semibold leading-none">
          Added To Cart!
        </p>
        <div className="border-t border-slate-200 dark:border-slate-700 my-4" />
        {renderProductCartOnNotify()}
      </Transition>
    ),
    { position: "top-right", id: "nc-product-notify" }
  );
  const renderProductCartOnNotify = () => {
    const item = itemData[0];
    let allPrice = itemData[0]?.onlinePrice;
    if (item.modifierSets) {
      item?.modifierSets.forEach((modifier: any) => {
        const matchingKey =
          item.modifierChecked &&
          Object.keys(item.modifierChecked)?.find(
            (key) => Number(key) === modifier.id
          );
        if (matchingKey) {
          modifier.modifierSetModifierItems?.forEach((modifierItems: any) => {
            const modifierItemId = modifierItems.id.toString();
            if (
              item.modifierChecked[matchingKey]?.[modifierItemId] !== undefined
            ) {
              allPrice += item.modifierChecked[matchingKey][modifierItemId]
                ? modifierItems.modifierItem.onlinePrice
                : 0;
            }
          });
        }
      });
    }
    return (
      <>
        {itemData.map((item: any, index: number) => (
          <div key={index} className="flex ">
            <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-xl bg-slate-100">
              {/* <img
                src={item.imageUrl}
                alt={item.name}
                className="h-full w-full object-cover object-center"
              /> */}
              <NcImage
                src={item.imageUrl}
                containerClassName="flex aspect-w-1 aspect-h-1 w-full h-0"
                className="w-full rounded-md object-cover"
              />
            </div>

            <div className="ml-4 flex flex-1 flex-col">
              <div>
                <div className="flex justify-between ">
                  <div>
                    <h3 className="text-base font-medium ">{item.name}</h3>
                    <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                      {/* <span className="mx-2 border-l border-slate-200 dark:border-slate-700 h-4"></span>
                          <span>
                            {item.isAvailable ? "Available" : "Unavailable"}
                          </span> */}
                    </p>
                  </div>
                  <Prices
                    onlinePrice={allPrice}
                    unit={item.unit?.name}
                    priceType={item.priceType?.name}
                    className="mt-0.5"
                  />
                </div>
              </div>
              <div className="flex flex-1 items-end justify-between text-sm">
                <p className="text-gray-500 dark:text-slate-400">
                  Qty {itemData[0].quantity}
                </p>

                <div className="flex">
                  {/* <Link
                        to={`/cart/${merchantname}`}
                        className="font-medium text-primary-6000 dark:text-primary-500"
                      >
                        View cart
                      </Link> */}
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };
  return;
}

export default NotifyCart;
